import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function Analytics() {
  const location = useLocation();

  useEffect(() => {
    // Self-hosted page view tracking
    axios.post(`${BACKEND_URL}/api/analytics/pageview`, {
      path: location.pathname,
      referrer: document.referrer,
    }).catch(() => {});

    // GA4 tracking (gated by consent)
    try {
      const consent = JSON.parse(localStorage.getItem('tb_consent_v1') || '{}');
      if (consent.analytics && window.gtag) {
        window.gtag('event', 'page_view', { page_path: location.pathname });
      }
    } catch {}
  }, [location.pathname]);

  return null;
}

export function initGA4(measurementId) {
  if (!measurementId || document.getElementById('ga4-script')) return;
  const script = document.createElement('script');
  script.id = 'ga4-script';
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
  window.gtag('config', measurementId, { send_page_view: false });
}
